// import { Modal } from "bootstrap";
import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  InputGroup,
  FormControl,
  Form,
  Container,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CandidateSearchBar from "../../../components/AdminCandidateSearch/AdminCandidateSearch";
import OrganizationSearch from "../../../components/OrganizationSearch/OrganizationSearch";
import { newAlert } from "../../../Slices/alertSlice";
import UserSearch from "../../../components/UserSearch/UserSearch";
import { createUser } from "../../../Slices/adminSlice";
import { showModal } from "../../../Slices/sessionSlice";
import SpinnerButton from "../../../components/SpinnerButton/SpinnerButton";
const createUserId = "createUser.create";
function CreateUser() {
  // const [showModal, setShowModal] = useState(false);
  const [selectedUser, setselectedUser] = useState(null);
  const [selectedOrganization, setselectedOrganization] = useState(null);
  const [candidatesSupervising, setCandidatesSupervising] = useState(null);
  const [role, setRole] = useState(null);
  const { activeModal } = useSelector((state) => state.sessionSlice);
  const dispatch = useDispatch();

  // #region SaveUser
  const saveUser = () => {
    if (!selectedUser) {
      return dispatch(
        newAlert({
          type: "danger",
          message: <span>Select A Valid User</span>,
        })
      );
    }
    if (!selectedOrganization) {
      return dispatch(
        newAlert({
          type: "danger",
          message: <span>Select A Valid Organization</span>,
        })
      );
    }
    if (role === "Supervisor" && !candidatesSupervising) {
      return dispatch(
        newAlert({
          type: "danger",
          message: <span>Assign Candidates For Supervisor</span>,
        })
      );
    }
    dispatch(
      showModal({
        id: "createUser.confirmation",
      })
    );
  };
  // #endregion
  return (
    <Container className="justify-content-around">
      <Row className="mt-4">
        <Col></Col>
        <Col>
          {" "}
          <h2>Create Tracker User</h2>
        </Col>
        <Col></Col>
      </Row>
      <Row className="mt-4">
        <Col></Col>
        <Col sm="5">
          <UserSearch
            handleSelection={setselectedUser}
            defaultSelected={null}
          />
        </Col>
        <Col></Col>
      </Row>
      <Row className="mt-4">
        <Col></Col>
        <Col sm="5">
          <OrganizationSearch
            handleSelection={setselectedOrganization}
            defaultSelected={null}
          />
        </Col>
        <Col></Col>
      </Row>
      <Row className="mt-4">
        <Col></Col>
        <Col sm="5">
          {role && role === "Supervisor" && (
            <CandidateSearchBar
              organization={selectedOrganization}
              defaultSelected={null}
              multiple={true}
              handleSelection={setCandidatesSupervising}
              placeholder={"Assign Candidates For Supervisor"}
            />
          )}
        </Col>
        <Col></Col>
      </Row>
      <Row
        className="mt-4"
        onClick={() => {
          setRole();
        }}
      >
        <Col></Col>
        <Col sm="8" className="text-center">
          <Form>
            <Form.Check
              inline
              type="radio"
              name="role-select"
              id="Supervisor"
              value={role}
              checked={role === "Supervisor"}
              label={<span className="h5">Supervisor</span>}
              onChange={(e) => {
                setRole(e.target.id);
              }}
            />
            <Form.Check
              inline
              type="radio"
              name="role-select"
              label={<span className="h5">Org Admin</span>}
              id="OrgAdmin"
              checked={role === "OrgAdmin"}
              value={role}
              onChange={(e) => {
                setRole(e.target.id);
              }}
            />
            {role && (
              <Button
                onClick={() => setRole()}
                className={"mb-2"}
                variant="link"
              >
                clear
              </Button>
            )}
          </Form>
        </Col>
        <Col></Col>
      </Row>
      <Row className="mt-4">
        <Col></Col>
        <Col className="text-center">
          <Button onClick={saveUser}>Create User</Button>
        </Col>
        <Col></Col>
      </Row>
      {Boolean(activeModal) && activeModal.id === "createUser.confirmation" && (
        <Modal
          show={true}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          top
          autoFocus
          animation
        >
          <Modal.Header>
            <Row className="w-100">
              <Modal.Title
                id="contained-modal-title-vcenter"
                style={{ marginLeft: "30vw" }}
              >
                Create User
              </Modal.Title>
            </Row>
          </Modal.Header>
          <Modal.Body>
            <Row className="w-100">
              <Col sm="12">
                <h4
                  style={{
                    marginLeft: "10vw",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  Assign{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {selectedUser.firstName} {selectedUser.lastName}
                  </span>{" "}
                  as{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {role || "Candidate"}
                  </span>{" "}
                  for{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {selectedOrganization._source.name}
                  </span>{" "}
                </h4>
                {/* <h4 style={{marginLeft:"25vw",marginTop:"20px",marginBottom:"20px"}}>Want To Proceed</h4> */}
              </Col>
            </Row>
            <Row>
              <Col
                sm="12"
                style={{
                  marginLeft: "29vw",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <SpinnerButton
                  variant="outline-primary"
                  id={createUserId}
                  name="Yes"
                  onClick={() => {
                    const payload = {
                      user: {
                        _id: selectedUser._id,
                        gender: selectedUser.gender,
                        profilePicUrl: selectedUser.profilePicUrl,
                        firstName: selectedUser.firstName,
                        lastName: selectedUser.lastName,
                        adminRole: selectedUser.adminRole,
                      },
                      organization: {
                        _id: selectedOrganization._source._id,
                        name: selectedOrganization._source.name,
                        logoUrl: selectedOrganization._source.logoUrl,
                        url: selectedOrganization._source.url,
                      },
                      candidatesSupervising: candidatesSupervising
                        ? candidatesSupervising.map(
                            (candidate) => candidate._id
                          )
                        : [],
                    };
                    if (role) {
                      payload.role = role;
                    }
                    console.log(payload, "datatobesend");
                    dispatch(createUser(payload));
                  }}
                />
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    dispatch(showModal(null));
                  }}
                  style={{ marginLeft: "80px" }}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      )}
    </Container>
  );
}

export default CreateUser;
